import Vue from 'vue';

export enum SearchEventBusEvents {
  FocusInput = 'focus-input',
  FocusCloseButton = 'focus-close-button',
}

export const SearchEventBus = new Vue();
